import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";

export const saveCredentialsInBrowser = (
  email: string | undefined,
  password: string | undefined
) => {
  try {
    const window = getWindowOrThrow();
    const navigator = window.navigator;
    if (
      navigator &&
      "credentials" in navigator &&
      "PasswordCredential" in window &&
      email &&
      password
    ) {
      // requires @types/webappsec-credential-management
      const cred = new PasswordCredential({ id: email, password });
      navigator.credentials.store(cred).catch(() => {});
    }
  } catch {
    // ignore any error, we don't want to block the user from signing up due to credentials management error
  }
};
